export default __webpack_public_path__ + "static/media/tete12.a5ad7dbd.png";